<template>
  <div>
    <!-- <v-sheet elevation="0" color="#57bc90" style="min-height: 70vh;">
      <p class="text-center">Stats will coming Soon !</p>
    </v-sheet> -->
    <v-sheet elevation="0" color="#57bc90" style="min-height: 70vh">
      <!-- //* game stats... -->
      <p class="text-h5 white--text font-weight-bold">Game Logs</p>
      <div class="mt-n3">
        <v-data-table
          :headers="header"
          :items="stats"
          class="elevation-1"
          hide-default-footer
          sort-by="Day"
          sort-desc
          mobile-breakpoint="0"
        >
          <!-- header -->
          <template
            v-for="h in header"
            v-slot:[`header.${h.value}`]="{ header }"
          >
            <v-tooltip bottom :key="h.text">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ h.text }}</span>
              </template>
              <span>{{ h.hint }}</span>
            </v-tooltip>
          </template>
          <!-- header -->

          <template v-slot:item.Day="{ item }">
            <p class="blue--text">{{ item.Day | dayFormatV2 }}</p>
          </template>
          Date $ per pts
        </v-data-table>
      </div>

      <!-- //* season stats... -->
      <!--      <p class="text-h5 white&#45;&#45;text font-weight-bold mt-3">-->
      <!--        Season Logs-->
      <!--      </p>-->
      <!--      <div class="mt-n3">-->
      <!--        <v-data-table-->
      <!--          :headers="seasonHeader"-->
      <!--          :items="stats"-->
      <!--          class="elevation-1"-->
      <!--          hide-default-footer-->
      <!--          sort-by="Day"-->
      <!--          sort-desc-->
      <!--          mobile-breakpoint="0"-->
      <!--        >-->
      <!--          &lt;!&ndash; header &ndash;&gt;-->
      <!--          <template-->
      <!--            v-for="h in seasonHeader"-->
      <!--            v-slot:[`header.${h.value}`]="{ seasonHeader }"-->
      <!--          >-->
      <!--            <v-tooltip bottom :key="h.text">-->
      <!--              <template v-slot:activator="{ on }">-->
      <!--                <span v-on="on">{{ h.text }}</span>-->
      <!--              </template>-->
      <!--              <span>{{ h.hint }}</span>-->
      <!--            </v-tooltip>-->
      <!--          </template>-->
      <!--          &lt;!&ndash; header &ndash;&gt;-->

      <!--          <template v-slot:item.Day="{ item }">-->
      <!--            <p class="blue&#45;&#45;text">{{ item.Day | dayFormatV2 }}</p>-->
      <!--          </template>-->

      <!--          <template v-slot:item.FantasyPointsDraftKings="{ item }">-->
      <!--            <p v-if="operator == 'FanDuel'" class="body-2">-->
      <!--              {{ item.FantasyPointsFanDuel }}-->
      <!--            </p>-->

      <!--            <p v-if="operator == 'DraftKings'" class="body-2">-->
      <!--              {{ item.FantasyPointsDraftKings }}-->
      <!--            </p>-->
      <!--          </template>-->
      <!--        </v-data-table>-->
      <!--      </div>-->
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "NhlfullStats",
  props: {
    stats: {
      type: [Array, Object],
      default: () => [],
    },
  },

  data: () => ({
    header: [
      { text: "Season", value: "Season", hint: "Season" },
      { text: "Team", value: "Opponent", hint: "Opponent" },
      { text: "A", value: "Assists", hint: "assist" },
      { text: "G", value: "Goals", hint: "goals" },
      { text: "PP", value: "PowerPlayGoals", hint: "power play" },
      { text: "PPA", value: "PowerPlayAssists", hint: "Power Play Assist" },
      { text: "SG", value: "ShootoutGoals", hint: "shoot out Goals" },
      { text: "SA", value: "ShortHandedAssists", hint: "short Hand Assist" },
      { text: "SH", value: "ShortHandedGoals", hint: "short Handed Goals" },
      { text: "S", value: "ShotsOnGoal", hint: "shots on goal" },
    ],

    seasonHeader: [
      { text: "Season", value: "Season", hint: "Season" },
      { text: "Opponent", value: "Opponent", hint: "Opponent" },
      { text: "A", value: "Assists", hint: "assist" },
      { text: "G", value: "Goals", hint: "goals" },
      { text: "PP", value: "PowerPlayGoals", hint: "power play" },
      { text: "PPA", value: "PowerPlayAssists", hint: "Power Play Assist" },
      { text: "SG", value: "ShootoutGoals", hint: "shoot out Goals" },
      { text: "SA", value: "ShortHandedAssists", hint: "short Hand Assist" },
      { text: "SH", value: "ShortHandedGoals", hint: "short Handed Goals" },
      { text: "S", value: "ShotsOnGoal", hint: "shots on goal" },
    ],
  }),
};
</script>

<style scoped>
.basil {
  background-color: #fffbe6 !important;
}
.basil--text {
  color: #356859 !important;
}
</style>
